export default __webpack_public_path__ + "static/media/atomic.f9de4253.png";